// extracted by mini-css-extract-plugin
module.exports = {"bar":"EcoBar_bar_3nzQ3","nocolor":"EcoBar_nocolor_2rQ3a"};